import React, { useEffect, useState } from 'react';
import { List, ListItem, ListItemText, ListItemAvatar, Avatar, IconButton } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DeleteIcon from '@mui/icons-material/Delete';
import { AvatarFromImage } from '../../../core/util/image/get-avatar-url';
import { Util } from '../../../core/util/util';
import { useUpdateImage } from '../../../core/hooks/update-image/useUpdateImage';


const SortableImageList = ({
    id,

    imagesFromDB,
    images,
    setImages,
    refDragDrop,
    disabled }) => {
    const [combinedImages, setCombinedImages] = useState([]);

    // const { setImprovedImageList } = useProductImageStore();

    useUpdateImage(id, combinedImages);

    useEffect(() => {
        // Filtra imágenes que no están ya en combinedImages
        const newDbImages = imagesFromDB.filter(dbImage =>
            !combinedImages.some(combinedImage => combinedImage.url === dbImage.url)
        );

        const newImages = images.filter(image =>
            !combinedImages.some(combinedImage => combinedImage.name === image.name)
        );

        // Combina las imágenes nuevas del DB con las existentes y ordena
        const updatedImages = [...combinedImages, ...newDbImages].sort((a, b) => a.position - b.position);
        setCombinedImages(updatedImages);
    }, [imagesFromDB]);

    useEffect(() => {

        if (images.length > 0) {
            // Filtra imágenes que no están ya en combinedImages
            // const newImages = images.filter(image =>
            //     !combinedImages.some(combinedImage => combinedImage.name === image.name)
            // );
            const newImages = images.filter(image =>
                !combinedImages.some(combinedImage => combinedImage.name === image.name && combinedImage.id === image.id)
            );

            // Combina las imágenes nuevas con las existentes y ordena
            const updatedImages = [...combinedImages, ...newImages].sort((a, b) => a.position - b.position);
            setCombinedImages(updatedImages);
        }

    }, [images]);

    const handleDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const reorderedImages = Array.from(combinedImages);
        const [movedImage] = reorderedImages.splice(result.source.index, 1);
        reorderedImages.splice(result.destination.index, 0, movedImage);

        // Actualiza las posiciones
        const updatedImages = reorderedImages.map((image, index) => ({ ...image, position: index }));

        setCombinedImages(updatedImages);
        setImages(updatedImages); // Actualiza el estado externo


        // TODO: Nuevo 4/8/24 - Actualiza el estado de las imágenes en el store
        // setImprovedImageList(id, updatedImages);

    };

    const handleDelete = async (name, id) => {
        refDragDrop.current.deleteFileItemByName(null, name, true);
        // refDragDrop.current.deleteFileItemById(null, id, true);

        // const updatedImages = combinedImages.filter(image => image.name !== name);
        const updatedImages = combinedImages.filter(
            (image) => !(image.name === name && image.id === id)
        );


        /**
         * TODO: Nuevo 5/8/24 - Actualiza el estado de las imágenes en el store
         * Los delay son necesarios porque cuando el listado llegaba a 0 no era correctamente eliminada la imagen 
         * y seguía perteneciendo en la lista que se mandaba al backend
         */
        if (updatedImages.length === 0) {
            await Util.delay(10);
            setCombinedImages(updatedImages);
            await Util.delay(10);
            setImages(updatedImages);
        } else {
            // Antiguo, funciona excepto cuando se elimina la última imagen
            setCombinedImages(updatedImages);
            setImages(updatedImages); // Actualiza el estado externo
        }


    };




    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable isDragDisabled={true} droppableId="images">
                {(provided) => (
                    <List {...provided.droppableProps} ref={provided.innerRef}>
                        {combinedImages.map((image, index) => (
                            <Draggable
                                key={image.id || image.url}
                                draggableId={image.id ? image.id.toString() : image.url}
                                index={index}
                                isDragDisabled={disabled} // Deshabilitar el drag-and-drop si disabled es true
                            >
                                {(provided) => (
                                    <ListItem
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                            ...provided.draggableProps.style,
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '8px',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            backgroundColor: '#f9f9f9',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                        }}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="square"
                                                sx={{ width: 56, height: 56, borderRadius: 1.5 }}
                                                src={AvatarFromImage.getAvatarUrl(image.url)}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText className='ml-8' primary={image.name} />

                                        {!disabled && (
                                            <span className='mr-4'>
                                                <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(image?.name, image?.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </span>
                                        )}

                                    </ListItem>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </List>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default SortableImageList;
